import { CreateElement, Point, Scale, Size, TranslatePointScreen1To1 } from "../.././MyHelpers";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { ZIndex } from "../../ZIndex";
import { MyCanvas } from "../MyCanvas";
import { ChangeSpeedParams } from "../SlotGameType1";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { FreegameBonus, FreegameBonusFactory, FreegameBonusParams, FreegamePickElementParams } from "./FreegameBonus";
import { FreegamePickElement } from "./FreegamePickElement";
import { FreegameSession } from "./FreegameSession";

export class FreegameBonus_1Screen extends FreegameBonus
{
	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		this.reelSpinAnimation.forEach(animation => {
			animation.UpdateSpinSpeed(changeSpeedParams.SpinParams)
		});
	}
	
    protected override plusOneTarget: Point = TranslatePointScreen1To1(new Point(Scale.X(280), Scale.Y(70)));
    protected containerfreegameStats: HTMLElement;
    protected freegameStatsRight: HTMLElement;
    protected FreegamesPlayedValue: HTMLElement;
    protected canvasFreegamesPlayedValue: MyCanvas;
    protected TotalPlayed: HTMLElement;
    protected freegameStatsLeft: HTMLElement;
    protected freegamesNumValue: HTMLElement;
    protected canvasfreegamesLeftValue: MyCanvas;
    protected FreegamesNumTitle: HTMLElement;    
    protected statsFontHeight : number = Scale.X(50);
	protected labelFontHeight : number = Scale.X(50);	
	public constructor(gameName: string, params: FreegameBonusParams ) 
	{
		super(gameName,params);		
	}  

    public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
        await super.PrepareResources(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.GamesPreload) return;
        this.spritesWinContainer(resourceManager);
    }    

    public spritesWinContainer(resourceManager: IWriteOnlyResourceManager){
		resourceManager.AddGlobal(new SpriteResource(this.params.gameResourcesBasePath + "resources/FreeGameBonus/ValueContainer", ResourceIdentifier.Global.Add("FreegamesBonus").Add(this.gameName+"ValueContainer"), true, this.logGroup.Add(this.gameName), true));
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/frameSprite", this.resid.Add("frameSprite"), true, this.logGroup.Add("frameSprite"), true));
	}

    public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
        await super.ResourcesLoaded(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.Games) return;

        this.createFreeGameStats(resourceManager);
    }
		
	protected createFreeGameStats(resourceManager: IReadOnlyResourceManager):void{
		//let freegameStats: HTMLElement = this.view.querySelector(".freegame-stats");
		this.containerfreegameStats = CreateElement("div",{classes:["freegame-stats"],parentToAppend : this.view , 
		style:{
			display: "flex",
				position: "absolute",
				width: "50%",
				height: "20%",
				//bottom: "0px",
				fontSize:"1em",
				flexDirection :"row",
                top: Scale.Ypx(-60),
                left:"0px",
				zIndex:ZIndex.freegameStats2.toString(),
		}});
		this.FreeGameStatsLeft(resourceManager);
		this.FreeGameStatsRight(resourceManager);
	}

	protected textPlayedCanvas:MyCanvas;
	protected FreeGameStatsRight(resourceManager: IReadOnlyResourceManager){
		this.freegameStatsRight = CreateElement("div", {
			classes: [this.resid.Scope() + "-freegameStatsRight"],
			style: {
				position: "relative",
				left: Scale.Xpx(0),
				//width: Scale.Wpx(422),
				height: "100%",
				//top: Scale.Ypx(415),
				display: "flex",
				justifyContent: "center",
				alignContent: "center",
				flexDirection:"column",
				margin:"auto",
				zIndex: ZIndex.freegameStats2.toString(),
				alignItems:"center",
				
			}
		});
		this.spinsPlayedSprite(resourceManager);

		this.FreegamesPlayedValue = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-right-value","freegames-played-num-value"],
			parentToAppend:this.freegameStatsRight,
			style: {
				position: "absolute",
				//left:Scale.Xpx(0),
				top:Scale.Xpx(-25),
				//width:Scale.Xpx(460),
				display:"flex",
				textAlign:"center",
				
			}
		});

		this.canvasFreegamesPlayedValue = this.createWinCountCanvas();
		this.SetTextCanvas("?",this.canvasFreegamesPlayedValue,this.statsFontHeight);
		this.FreegamesPlayedValue.appendChild(this.canvasFreegamesPlayedValue.View());

		this.TotalPlayed = CreateElement("div", {
			classes: [this.resid.Scope() + "-total-played"],
			parentToAppend: this.freegameStatsRight,
			style: {
				position: "relative",
				top:Scale.Xpx(-56),
				//lineHeight:Scale.fhpx(77),
				fontSize:Scale.fh(4.5)+"em",
				fontFamily:this.resid.ScopedResourceName("font"),				
				color:"yellow",
				textAlign:"center",
				alignItems:"center",
				alignContent:"center",
				alignSelf:"center",
				//margin:Scale.XYpx(25),
				//zIndex:ZIndex.freegameStatsRight.toString(),
				textShadow: `0px ${Scale.Xpx(10)} ${Scale.Ypx(10)} black, 0px 0px ${Scale.Ypx(10)} black, 0px 0px ${Scale.XYpx(20)} black`

			}
		});
		this.containerfreegameStats.appendChild(this.freegameStatsRight);	
		this.freegameStatsRight.appendChild(this.TotalPlayed);

		this.textPlayedCanvas = this.createTextInfoCanvas();
		this.SetTextCanvas(this.translator.t.played,this.textPlayedCanvas,this.labelFontHeight);
		this.translator.SetOnLanguageChangedCallback(() => this.SetTextCanvas(this.translator.t.played,this.textPlayedCanvas,this.labelFontHeight));
		this.TotalPlayed.appendChild(this.textPlayedCanvas.View());

		//this.spinsPlayedSprite(resourceManager);
	}
   
	protected textLeftCanvas:MyCanvas;
	protected FreeGameStatsLeft(resourceManager: IReadOnlyResourceManager)
	{
		this.freegameStatsLeft = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegame-stats"],
			parentToAppend:this.containerfreegameStats,
			style: {
				display:"flex",
				position: "relative",
				//width:Scale.Wpx(422),
				height:"100%",
				//top:Scale.Ypx(415),
				zIndex:ZIndex.freegameStats2.toString(),
				left:Scale.Ypx(0),
				justifyContent:"center",
				flexDirection:"column",
				margin:"auto",
				alignItems:"center",
			}
		});

		this.spinsRemainingSprite(resourceManager);

		this.freegamesNumValue = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-left-value","freegames-num-value"],
			parentToAppend:this.freegameStatsLeft,
			style: {
				position: "absolute",
				//left:Scale.Xpx(0),
				top:Scale.Xpx(-25),
				// width:Scale.Xpx(460),
				display:"flex",
				textAlign:"center",
			
				
			}
		});
		
		this.canvasfreegamesLeftValue = this.createWinCountCanvas();		
		this.SetTextCanvas("?",this.canvasfreegamesLeftValue,this.statsFontHeight);
		this.freegamesNumValue.appendChild(this.canvasfreegamesLeftValue.View());

		this.FreegamesNumTitle = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-left-title"],
			parentToAppend:this.freegameStatsLeft,
			style: {
				position: "relative",
				top:Scale.Xpx(-56),
				//lineHeight:Scale.fhpx(77),
				fontSize:Scale.fh(4.5)+"em",
				fontFamily:this.resid.ScopedResourceName("font"),				
				color:"yellow",
				textAlign:"center",
				alignItems:"center",
				alignContent:"center",
				alignSelf:"center",
				//margin:Scale.XYpx(25),
				textShadow: `0px ${Scale.Xpx(10)} ${Scale.Ypx(10)} black, 0px 0px ${Scale.Ypx(10)} black, 0px 0px ${Scale.XYpx(20)} black`
			}
		});

		this.textLeftCanvas = this.createTextInfoCanvas();
		this.SetTextCanvas(this.translator.t.totalleftHoldAndSpin,this.textLeftCanvas,this.labelFontHeight);
		this.translator.SetOnLanguageChangedCallback(() => this.SetTextCanvas(this.translator.t.totalleftHoldAndSpin,this.textLeftCanvas,this.labelFontHeight));
		this.FreegamesNumTitle.appendChild(this.textLeftCanvas.View());	

		//this.spinsRemainingSprite(resourceManager);
	}

	//container for spins wins
	protected spinsPlayedBackgroundSprite: CanvasSprite = null;
	//container for spins left
	protected spinsRemainingBackgroundSprite:CanvasSprite=null;
	protected spinsRemainingSprite(resourceManager: IReadOnlyResourceManager)
	{
		this.spinsRemainingBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("FreegamesBonus").Add(this.gameName+"ValueContainer")).sprite, canvasSize: new Size(Scale.W(180), Scale.H(180))});
		//this.spinsRemainingBackgroundSprite.Start(true);
		this.spinsRemainingBackgroundSprite.View().style.position="relative";
		this.spinsRemainingBackgroundSprite.View().style.left=Scale.Xpx(0);
		this.spinsRemainingBackgroundSprite.View().style.top=Scale.Ypx(0);
		this.freegameStatsLeft.appendChild(this.spinsRemainingBackgroundSprite.View());

	}

	protected spinsPlayedSprite(resourceManager: IReadOnlyResourceManager)
	{
		this.spinsPlayedBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("FreegamesBonus").Add(this.gameName+"ValueContainer")).sprite, canvasSize: new Size(Scale.W(180), Scale.H(180))});
		//this.spinsPlayedBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.View().style.position="relative";
		//this.spinsPlayedBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.View().style.left=Scale.Xpx(0);
		this.spinsPlayedBackgroundSprite.View().style.top=Scale.Ypx(0);
		this.freegameStatsRight.appendChild(this.spinsPlayedBackgroundSprite.View());
		
	}

    protected createTextInfoCanvas():MyCanvas{
		let canvas = new MyCanvas(new Size(Scale.W(500), Scale.H(100)), {
			style: {
				//left: Scale.Xpx(0),
				//top: Scale.Ypx(0),
				//position: "absolute",
				zIndex: ""+ ZIndex.freegameStats2
			}
		});

		return canvas;
	}

    protected createWinCountCanvas():MyCanvas{
		let canvas = new MyCanvas(new Size(Scale.W(150), Scale.H(150)), {
			style: {
				left: Scale.Xpx(0),
				top: Scale.Ypx(0),
				position: "relative",
				zIndex: ""+ ZIndex.BonusWin
			}
		});

		return canvas;
	}


    public override Start(): void {
        super.Start();
        this.SetTextCanvas(this.session.played.toString(), this.canvasFreegamesPlayedValue, this.statsFontHeight);
		this.SetTextCanvas(this.session.left.toString(), this.canvasfreegamesLeftValue, this.statsFontHeight);	
    }

    protected override OnSpinBegin(): void {
        this.session.left--;
		this.session.played++;
		this.audio.Play(this.parentresid.ScopedResourceName("leverpull"));
        //Update Stats for 1 screen game for new Spin
		this.ApplySession(this.session);
		this.OnBonusRunResult();
    }

    protected redrawCanasWinCount(){
		if (this.canvasFreegamesPlayedValue.WasContextLost()) {
			this.SetTextCanvas(this.session.played.toString(), this.canvasFreegamesPlayedValue, this.statsFontHeight);
		}
		if (this.canvasfreegamesLeftValue.WasContextLost()) {
			this.SetTextCanvas(this.session.left.toString(), this.canvasfreegamesLeftValue, this.statsFontHeight);
		}
		if(this.textPlayedCanvas.WasContextLost()){
			this.SetTextCanvas(this.translator.t.played,this.textPlayedCanvas,this.labelFontHeight);
		}
		if(this.textLeftCanvas.WasContextLost()){
			this.SetTextCanvas(this.translator.t.totalleftHoldAndSpin,this.textLeftCanvas,this.labelFontHeight);
		}		
	}

    public override Update(): void {
        super.Update();
        this.spinsPlayedBackgroundSprite.Update();
        this.spinsRemainingBackgroundSprite.Update();
        this.redrawCanasWinCount();
    }

    //Create For Update The Session For RunsRemaining 1 Screen Game
	protected override ApplySession( session:FreegameSession ): void{		
        //setTimeout(() => {
            //Update Stats for 1 screen game			
            this.SetTextCanvas(session.played.toString(), this.canvasFreegamesPlayedValue, this.statsFontHeight);
            this.SetTextCanvas(session.left.toString(), this.canvasfreegamesLeftValue, this.statsFontHeight);							
        //}, 1500);
	}
	protected override async BaseLoaded(resourceManager: IReadOnlyResourceManager) 
	{
		// super.BaseLoaded(resourceManager)
        // this.gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"])).CssBackground();	
		await this.LoadTransition(resourceManager);
	}

}

export class FreegameBonusFactory_1Screen extends FreegameBonusFactory
{
	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus
	{
		return new FreegameBonus_1Screen(gameName, params);
	}

	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement
	{
		return new FreegamePickElement(params);
	}
}
